<template>
  <div style="width: 100%">
    <el-popover
      v-model="visible"
      placemen="bottom"
      trigger="manual"
    ><!--todo 点击选择下拉框时调整为不显示form内容-->
      <el-select slot="reference" v-model="value" style="width: 100%" filterable @change="accountTitleChangeHandler" @visible-change="onVisibleChange">
        <el-option
          v-for="item in params.accountTitles"
          :key="item.uuid"
          :label="item.accountTitle+' '+item.accountTitleName"
          :value="item.accountTitle"
        />
      </el-select>
      <el-form v-if="accountTitleVisible" label-width="60px">
        <el-form-item v-if="accountTitle.auxiliaryCustomer" :label="$t('FinanceManage.Client')">
          <cargo-advance-select
            ref="customerSelect"
            filterable
            :select-type="selectTypeNames.basic_data_Company"
            callback-method-type="value"
            :default-value="form.auxiliaryCustomer"
            @parentCallBack="p=>{form.auxiliaryCustomer=p;updateDataValue()}"
          />
        </el-form-item>
        <el-form-item v-if="accountTitle.auxiliarySupplier" :label="$t('FinanceManage.Supplier')">
          <cargo-advance-select
            ref="supplierSelect"
            filterable
            :select-type="selectTypeNames.basic_data_Company"
            callback-method-type="value"
            :default-value="form.auxiliarySupplier"
            @parentCallBack="p=>{form.auxiliarySupplier=p;updateDataValue()}"
          />
        </el-form-item>
        <el-form-item v-if="accountTitle.auxiliaryDepartment" :label="$t('FinanceManage.Department')">
          <cargo-advance-select
            ref="departmentSelect"
            filterable
            :select-type="selectTypeNames.basic_data_Department"
            callback-method-type="value"
            :default-value="form.auxiliaryDepartment"
            :method-params="{officeUuid:$store.getters.currentOfficeUuid}"
            @parentCallBack="p=>{form.auxiliaryDepartment=p;updateDataValue()}"
          />
        </el-form-item>
        <el-form-item v-if="accountTitle.auxiliarySales" :label="$t('FinanceManage.Staff')">
          <cargo-advance-select
            ref="salesSelect"
            filterable
            :select-type="selectTypeNames.basic_data_User"
            callback-method-type="value"
            :default-value="form.auxiliarySales"
            :cache="false"
            :static-options="salesList"
            @parentCallBack="p=>{form.auxiliarySales=p;updateDataValue()}"
          />
        </el-form-item>
        <el-form-item v-if="accountTitle.auxiliaryProjectNumber" :label="$t('FinanceManage.Project')">
          <el-input
            v-model="form.auxiliaryProject"
            @change="updateDataValue"
          />
        </el-form-item>
      </el-form>
    </el-popover>
  </div>
</template>

<script>
import Vue from 'vue'
import TableKeyboardNav from '@/mixin/TableKeyboardNav'
import CargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import ColumnUtils from '@/utils/ColumnUtils'
import StrUtils from '@/utils/StrUtils'

export default Vue.extend({
  name: 'AccountTitleEditor',
  components: { CargoAdvanceSelect },
  mixins: [TableKeyboardNav],
  data() {
    return {
      visible: false,
      selectTypeNames: TYPE_NAMES,
      accountTitleUuid: '',
      accountTitle: {
        auxiliary: false,
        auxiliaryCustomer: false,
        auxiliarySupplier: false,
        auxiliaryDepartment: false,
        auxiliarySales: false,
        auxiliaryProjectNumber: false
      },
      form: {
        auxiliaryCustomer: 0,
        auxiliarySupplier: 0,
        auxiliarySales: 0,
        auxiliaryDepartment: 0,
        auxiliaryProject: ''
      },
      auxiliaryString: '',
      value: ''
    }
  },
  computed: {
    accountTitleVisible() {
      if (this.value) {
        this.accountTitle = this.params.accountTitles.find(title => title.accountTitle === this.value)
        if (!this.accountTitle) return false
        if (this.accountTitle.auxiliary || this.accountTitle.auxiliaryCustomer ||
          this.accountTitle.auxiliarySupplier || this.accountTitle.auxiliaryDepartment ||
          this.accountTitle.auxiliarySales || this.accountTitle.auxiliaryProjectNumber) {
          return true
        } else {
          return false
        }
      } else {
        return false
      }
    },
    salesList() {
      if (this.form.auxiliaryDepartment > 0) {
        const data = []
        this.params.salesList.forEach((p) => {
          if (p.defaultDepId === this.form.auxiliaryDepartment) data.push(p)
        })
        return data
      } else {
        return this.params.salesList
      }
    }
  },
  created() {
    // console.log('oninputeditor')
    // this.value = this.params.value
  },
  mounted() {
    this.value = this.params.value ? this.params.value.split(' ')[0] : ''
    this.form.auxiliaryCustomer = 0
    this.form.auxiliarySupplier = 0
    this.form.auxiliarySales = 0
    this.form.auxiliaryDepartment = 0
    this.form.auxiliaryProject = ''
    if (this.params.accountingEntry && this.params.accountingEntry.accountTitle !== undefined) {
      this.form.auxiliaryCustomer = this.params.accountingEntry.auxiliaryCustomer ? this.params.accountingEntry.auxiliaryCustomer : this.params.accountingEntry.accountClient
      this.form.auxiliarySupplier = this.params.accountingEntry.auxiliarySupplier ? this.params.accountingEntry.auxiliarySupplier : this.params.accountingEntry.accountClient
      this.form.auxiliarySales = this.params.accountingEntry.sales
      this.form.auxiliaryDepartment = this.params.accountingEntry.projectNumber
      this.form.auxiliaryProject = this.params.accountingEntry.department
    }
    this.$nextTick(() => {
      if (this.$refs.input) {
        this.$refs.input.focus()
        this.$refs.input.select()
      }
    })
    setTimeout(() => {
      window.addEventListener('click', this.clickOther)
    }, 100)
  },
  destroyed() {
    window.removeEventListener('click', this.clickOther)
  },
  methods: {
    getValue() {
      if (this.value) {
        this.accountTitle = this.params.accountTitles.find(title => title.accountTitle === this.value)
        if (!this.accountTitle) return ''
        let msg = this.accountTitle.accountTitle + ' ' + this.accountTitle.accountTitleName
        const auxiliaryStr = this.fillVoFromAuxiliary()
        if (auxiliaryStr) {
          msg += ' \n' + auxiliaryStr
        }
        return msg
      }
      return ''
    },
    accountTitleChangeHandler(newVal) {
      this.accountTitle = this.params.accountTitles.find(title => title.accountTitle === newVal)
      this.value = newVal
      // 显示数据
      // this.visible = true
      // 显示
      console.log(newVal)
      this.updateDataValue()
    },
    onVisibleChange(show) {
      console.log('onVisibleChange-' + show)
      if (show) {
        this.visible = false
      } else {
        this.visible = this.accountTitleVisible
      }
    },
    fillVoFromAuxiliary() {
      if (this.accountTitle) {
        let auxiliaryStr = ''
        const accountTitle = this.accountTitle
        this.params.accountingEntry.accountTitle = accountTitle.accountTitle
        this.params.accountingEntry.accountTitleName = accountTitle.accountTitleName
        if (accountTitle && accountTitle.auxiliary) {
          if (accountTitle.auxiliaryCustomer) {
            if (auxiliaryStr) {
              auxiliaryStr += '/'
            }
            if (this.form.auxiliaryCustomer) {
              const customer = ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', this.form.auxiliaryCustomer, 'chineseName')
              if (!StrUtils.isEmpty(customer)) auxiliaryStr += customer
            }
            this.params.accountingEntry.accountClient = this.form.auxiliaryCustomer
            this.params.accountingEntry.auxiliaryCustomer = this.form.auxiliaryCustomer
          }
          if (accountTitle.auxiliarySupplier) {
            if (auxiliaryStr) {
              auxiliaryStr += '/'
            }
            if (this.form.auxiliarySupplier) {
              const supplier = ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', this.form.auxiliarySupplier, 'chineseName')
              if (!StrUtils.isEmpty(supplier)) auxiliaryStr += supplier
            }
            this.params.accountingEntry.accountClient = this.form.auxiliarySupplier
            this.params.accountingEntry.auxiliarySupplier = this.form.auxiliarySupplier
          }
          if (accountTitle.auxiliaryDepartment) {
            if (auxiliaryStr) {
              auxiliaryStr += '/'
            }
            if (this.form.auxiliaryDepartment) {
              const department = ColumnUtils.departmentLabelNewFunc(this.form.auxiliaryDepartment)
              if (!StrUtils.isEmpty(department)) auxiliaryStr += department
            }
            this.params.accountingEntry.department = this.form.auxiliaryDepartment
          }
          if (accountTitle.auxiliarySales) {
            if (auxiliaryStr) {
              auxiliaryStr += '/'
            }
            if (this.form.auxiliarySales) {
              const sales = ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', this.form.auxiliarySales, 'chineseName')
              if (!StrUtils.isEmpty(sales)) auxiliaryStr += sales
            }
            this.params.accountingEntry.sales = this.form.auxiliarySales
          }
          if (accountTitle.auxiliaryProjectNumber) {
            if (auxiliaryStr) {
              auxiliaryStr += '/'
            }
            if (this.form.auxiliaryProject) {
              auxiliaryStr += this.form.auxiliaryProject
            }
            this.params.accountingEntry.projectNumber = this.form.auxiliaryProject
          }
          this.auxiliaryString = auxiliaryStr
          return auxiliaryStr
        }
      }
    },
    updateDataValue() {
      this.params.node.setDataValue(this.params.column.colId, this.getValue())
    },
    clickOther(e) {
      if (!this.$el.contains(e.target)) {
        this.params.api.stopEditing()
      }
    }
  }
})
</script>
